module.exports = __webpack_public_path__ + "img/information (1).2508df20.svg";